import { ChangeEvent, useContext } from 'react';

import { ReactComponent as CloseIcon } from '@/assets/icons/search-close.svg';
import { ReactComponent as SearchIcon } from '@/assets/icons/search-icon.svg';

import classes from './P2PAdminPanel.module.css';
import { P2PContext } from './P2PContext';

const P2PListSearch: React.FC<{}> = () => {
    const context = useContext(P2PContext);
    const { searchValue, setSearchValue } = context;

    const changeSearchHandler = (ev: ChangeEvent<HTMLInputElement>) => {
        const value = ev.target.value;
        setSearchValue(value);
    };
    return (
        <div className={classes['search']}>
            <SearchIcon height={28} className={classes['search-icon']} />
            <input
                placeholder="Search"
                value={searchValue}
                onChange={changeSearchHandler}
                className={classes.input}
                type="text"
            />
            <CloseIcon
                className={`${classes['search-close']}
                        ${
                            searchValue && searchValue !== ''
                                ? classes['visible']
                                : ''
                        }
                    `}
                onClick={() => setSearchValue('')}
            />
        </div>
    );
};
export default P2PListSearch;
